/**
 * 支付
 */
import payApi from '../../api/pay.api'

const state = {
    list: []
};

const getters = {
};

const mutations = {
    setList(state, data) {
        state.list = data;
    }
};

const actions = {
    // 获取支付产品列表
    getPayList({commit}) {
        return payApi.getList().then(res => {
            commit('setList', res);
            return res;
        })
    },
    //添加开发票
    addOrderInvoice({commit},params) {
        return payApi.addOrderInvoice(params)
    },
    //获取最后一个订单
    getOrderOnce({commit}, params) {
        return payApi.getOrderOnce(params);
    },
    // 获取单个支付产品
    getPayItem({}, key) {
        return payApi.getItem(key);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./app/store/modules/pay.js